export default "__VITE_ASSET__BYeqGq4N__"